export const newTimesheet = {
  // Timesheet Tabs
  CREATING_TIMESHEET: "Creating Timesheet",
 REPORTS: "Invoiced Timesheet",
  WORKED_HOURS: "Worked Hours",
  
  // Timesheet Header
  TIMESHEET_RECORDS: "Timesheet Records",
  SEARCH: "Search",
  CLIENT: "Client",
  ALL_CLIENTS: "All Clients",
  SELECT_CLIENT: "Select client",
  DATE: "Date",
  INVOICE_BY_TIMESHEET: "Invoice By Timesheet",
  ADD_RECORD: "Add Record",
  TIMESHEET_RECORD: "Timesheet record",
  TIME_OFF_ABSENSE: "Time off / Absense",
  
  // Add Timesheet Sidebar
  ADD_TIMESHEET_RECORD: "Add Timesheet Record",
  NO_CLIENTS_FOUND: "No clients found",
  CLIENT_DETAILS: "Client Details",
  TASK_DETAILS: "Task Details",
  ENTER_TASK_DETAILS: "Enter task details",
  FROM_DATE: "From Date",
  TO_DATE: "To Date",
  CLOCK_IN_TIME: "Clock In Time",
  CLOCK_OUT_TIME: "Clock Out Time",
  PRICING_TYPE: "Pricing Type",
  PRICE: "Price",
  ENTER_VALUE: "Enter value",
  CANCEL: "Cancel",
  SUBMIT: "Submit",
  LOADING: "Loading...",
  
  // Pricing Types
  HOURLY: "Payment per Hour",
  HOURLY_WAGES: "Payment per hour",
  PAYMENT_PER_DAY: "Payment per day",
  PAYMENT_PER_WEEK: "Payment per week",
  PAYMENT_PER_MONTH: "Payment per month",
  PAYMENT_PER_AGREED: "Payment per Agreed",
  
  // Timesheet Table
  TASK_DETAILS_HEADER: "Task Details",
  PRICE_HEADER: "Price",
  HOURS_HH_MM: "Hours (HH:MM)",
  HOLIDAY: "Holiday",
  YES: "Yes",
  NO: "No",
  ENTER_TASK_DETAILS_PLACEHOLDER: "Enter task details",
  
  // Week Group
  WEEK: "Week",
  CUSTOMER: "Customer",
  
  // Pagination
  PREVIOUS: "Previous",
  NEXT: "Next",
  
  // Time Off Sidebar
  ADD_TIME_OFF_RECORD: "Add Time Off Record",
  TIME_OFF_TYPE: "Time Off Type",
  TIME_OFF_PRICING: "Time Off Pricing",
  CURRENCY: "Currency",
  PRICING: "Pricing",
  HOURS_FOR_DAY: "Hours for Day",
  
  // Invoice By Timesheet Modal
  INVOICE_BY_TIMESHEET_TITLE: "Invoice By Timesheet",
  SELECT_CUSTOMER_PLACEHOLDER: "Select customer",
  SELECT_MONTH: "Select Month",
  SELECT_YEAR: "Select Year",
  JANUARY: "January",
  FEBRUARY: "February",
  MARCH: "March",
  APRIL: "April",
  MAY: "May",
  JUNE: "June",
  JULY: "July",
  AUGUST: "August",
  SEPTEMBER: "September",
  OCTOBER: "October",
  NOVEMBER: "November",
  DECEMBER: "December",
  
  // Filter Header
  LOAD: "Load",
  SAVE: "Save",
  CONFIRM_SAVE: "Confirm Save",
  ARE_YOU_SURE_SAVE_TIMESHEET: "Are you sure you want to save the timesheet?",
  SAVING: "Saving...",
  CONFIRM_EDIT: "Confirm Edit",
  ARE_YOU_SURE_SAVE_CHANGES: "Are you sure you want to save the changes?",
  
  // Validation & Messages
  NO_DATA_AVAILABLE: "No data available",
  SELECT_DATES_ABOVE: "Select dates above",
  ENTER_SERVICE_NAME: "Enter service name",
  SEARCH_SELECT_SERVICE: "Search & select service",
  UNITS: "Units",
  ENTER_UNITS: "Enter units",
  
  // Service Types (RUT/ROT)
  BUILD: "Build",
  ELECTRICITY: "Electricity",
  GLASS_SHEET_METAL: "Glass & Sheet Metal",
  SOIL_DRAINAGE: "Soil & Drainage",
  PAINTING_WALLPAPERING: "Painting & Wallpapering",
  PLUMBING: "Plumbing",
  MASONRY: "Masonry",
  
  // Common
  SERVICE: "Service",
  TIME: "Time",
  SUBTOTAL: "Subtotal",
  DISCOUNT: "Discount",
  DATE_S_HEADER: "Date(s)",
  ADD_NEW_ROW: "Add New Row",
  TIM: "Tim",
  DAG: "Dag",
  VECKA: "vecka",
  M: "m",
  A: "a",
  
  // Worked Hours Page
  FROM: "From",
  TO: "To",
  MONTHLY_CALENDAR_SUMMARY: "Monthly Calendar Summary",
  THIS_WILL_DISPLAY_ON_INVOICE: "This will display on the invoice",
  SERIAL_NO: "Serial No.",
  USER_ID: "User ID",
  ABSENCES: "Absences",
  HOURS: "Hours",
  HOURSS: "Hours",
  ISSUED_DATE: "Issued Date",
  ACTION: "Action",
  PREV: "Prev",
  
  // Timesheet Reports
 SHARED_REPORTS: "Invoiced Timesheet",
  BULK_ACTION: "Bulk Action",
  EXPORT_SELECTED: "Export Selected",
  DELETE_SELECTED: "Delete Selected",
  SHARE_SELECTED: "Share Selected",
  NO_REPORTS_FOUND: "No reports found",
  DOWNLOAD: "Download",
  DELETE: "Delete",  
  // Delete Confirmation
  CONFIRM_DELETE: "Confirm Delete",
  ARE_YOU_SURE_DELETE_ENTRY: "Are you sure you want to delete this entry?",
  DELETING: "Deleting...",
  
  // API Response Messages
  SUCCESS: "Success",
  TIMESHEET_SAVED_SUCCESSFULLY: "Timesheet saved successfully",
  FAILED_TO_SAVE_TIMESHEET: "Failed to save timesheet",
  FAILED_TO_FETCH_TIMESHEET: "Failed to fetch timesheet",
  FAILED_TO_FETCH_EMPLOYEE_WORKING_HOURS: "Failed to fetch employee working hours",
  TIMESHEET_ENTRY_DELETED_SUCCESSFULLY: "Timesheet entry deleted successfully",
  FAILED_TO_DELETE_TIMESHEET_ENTRY: "Failed to delete timesheet entry",
  WORKING_HOUR_DELETED_SUCCESSFULLY: "This working hour deleted successfully",
  TIMESHEET_UPDATED_SUCCESSFULLY: "Timesheet updated successfully",
  FAILED_TO_UPDATE_TIMESHEET: "Failed to update timesheet",
  TIMESHEET_WORKING_HOUR_UPDATED: "Timesheet working hour updated",
  SOMETHING_WENT_WRONG: "Something went wrong",
  FAILED_TO_FETCH_TIMESHEET_REPORT: "Failed to fetch timesheet report",
  
  // Validation Error Messages
  CUSTOMER_REQUIRED: "Customer is required",
  TASK_DETAILS_REQUIRED: "Task details are required",
  TASK_DETAILS_MAX_42_CHARACTERS: "Task details cannot exceed 42 characters",
  TASK_DETAILS_LATIN_ONLY: "Only Latin characters are allowed",
  CHARACTERS: "characters",
  FROM_DATE_REQUIRED: "From date is required",
  TO_DATE_REQUIRED: "To date is required",
  TO_DATE_MUST_BE_AFTER_FROM_DATE: "To date must be after from date",
  CLOCK_IN_TIME_REQUIRED: "Clock in time is required",
  CLOCK_OUT_TIME_REQUIRED: "Clock out time is required",  HOURS_REQUIRED: "Hours are required",
  HOURS_INVALID_FORMAT: "Invalid time format. Use HH:MM",
  HOURS_MAX_23_59: "Hours cannot exceed 23:59",  PRICING_TYPE_REQUIRED: "Pricing type is required",
  PRICE_REQUIRED: "Price is required",
  PRICE_MUST_BE_POSITIVE: "Price must be greater than 0",
  PLEASE_SELECT_DATES: "Please select at least one date",
  ONLY_LATIN_CHARACTERS_ALLOWED: "Only Latin characters are allowed",
  SERVICE_DESCRIPTION_MAX_CHARS: "Maximum 42 characters allowed",
  
  // Auto Generate Items Modal
  AUTO_GENERATE_ITEMS: "Add Multiple Rows",
  AUTO_GENERATE_DESCRIPTION: "Configure the parameters to automatically generate invoice line items for selected dates.",
  HOURS_PER_DAY: "Hours per day",
  SELECT_DATES: "Select dates",
  CLICK_TO_SELECT_DATES: "Click to select dates",
  SERVICE_DESCRIPTION: "Service description",
  ENTER_SERVICE_DESCRIPTION: "Enter service description",
  GENERATES: "Add Rows",
  
  // Tooltips
  PRICING_TYPE_TOOLTIP: "Choose how your pricing is calculated — for example, based on time or a fixed rate.",
  HOURS_PER_DAY_TOOLTIP: "Enter the number of hours you typically work per day for this project.",
  HOURLY_PRICE_TOOLTIP: "Set the amount you charge per hour of work.",
  DATES_TOOLTIP: "Indicate the dates when the work was performed.",
  CALENDAR_TOOLTIP: "Click to select a date. Drag to select multiple dates.",
  SERVICE_DESCRIPTION_TOOLTIP: "Describe your service (max 42 characters). Only Latin characters are allowed (A-Z, a-z, 0-9, spaces, and common punctuation).",
  
  // Timesheet Filter Header
  FROMS: "From",
  TO: "To",
  DD_MM_YYYY: "dd/mm/yyyy",
  LOAD: "Load",
  SAVE_TIMESHEET: "Save Timesheet",
  
  // Invoice by Timesheet Modal
  CREATE_INVOICE_BY_TIMESHEET: "Create invoice by timesheet",
  INVOICE_MODAL_DESCRIPTION: "Please enter the below details and it will update your invoice accordingly.",
  SUBMITTING: "Submitting...",
  
  // Invoice by Timesheet Modal Validation
  CLIENT_REQUIRED: "Client is required",
  PLEASE_FILL_ALL_REQUIRED_FIELDS: "Please fill all required fields",
  DATE_IS_REQUIRED: "Date is required",
  NO_TIMESHEET_WORKING_HOURS_FOUND: "No timesheet working hours found. Please create and save timesheet working hours first, then create invoice.",
  
  // Freelancer removal confirmation
  REMOVE_FREELANCER_TITLE: "Remove freelancer from this collective invoice?",
  REMOVE_FREELANCER: "Remove Freelancer",
   CONFIRM_REMOVE_FREELANCER_MESSAGE: "Removing <strong>{{name}}</strong> from this collective invoice will delete all their invoice activity data here (dates, hours, discounts).<br/><br/>This can't be undone. Continue?",
  CANCEL_BUTTON: "Cancel",
  REMOVE_FREELANCER_BUTTON: "Remove Freelancer",
  NO_CANCEL: "No, Cancel",
  YES_REMOVE: "Yes, Remove",
  SELECT_CUSTOMER_FIRST_TOOLTIP: "Please select customer first to select working hours",
  
  // Unsaved Timesheet Warning Modal
  UNSAVED_TIMESHEET_WARNING_TITLE: "Save New Working Rows",
  UNSAVED_TIMESHEET_CONFIRMATION_MESSAGE: "You have unsaved changes in your timesheet. Would you like to save them before proceeding?",
  UNSAVED_TIMESHEET_CANCEL_BUTTON: "No, don't save and continue",
  UNSAVED_TIMESHEET_SAVE_CONTINUE_BUTTON: "Save and Continue",
  SAVING: "Saving...",
  
  // Deduction Page
  DEDUCTIONS_LABEL: "Deductions",
  DEDUCTION_DESCRIPTION: "Here are all the deductions made via invoices created through Invozio.",
  INVOICED: "Invoiced",
  NOT_INVOICED: "Not Invoiced",
  ALL_MONTHS: "All Months",
  ALL_YEARS: "All Years",
  ALL_CUSTOMERS: "All Customers",
  ADD_DEDUCTION: "Add Deduction",
  NOT_INVOICED_DEDUCTIONS: "Not Invoiced Deductions",
  NOT_INVOICED_DESCRIPTION: "This section will display deductions that have not yet been invoiced.",
  DEDUCTIONS: "Deduction",
  PERIOD: "Period",
  NOT_INVOICED_STATUS: "Not invoiced",
  EDIT: "Edit",  SELECT_CUSTOMER: "Select Customer",
  
  // Deduction Toast Messages
  DEDUCTION_CREATED_SUCCESSFULLY: "Deduction created successfully",
  DEDUCTION_UPDATED_SUCCESSFULLY: "Deduction updated successfully",
  DEDUCTION_SUBMIT_FAILED: "Failed to submit deduction",  
  // OTP Modal translations
  "Verify OTP": "Verify OTP",
  "Verify your current email": "Verify your current email",
  "Step 2: Verify your current email": "Step 2: Verify your current email",
  "Please check your new email inbox": "Please check your new email inbox",
  "for the one-time code.": "for the one-time code.",
  "Enter the OTP sent to your current email address": "Enter the OTP sent to your current email address",
  "Verify": "Verify",
  "Resend in": "Resend in",
  "Resend": "Resend",
};
